<template src="./template.html"/>
<style scoped src="./stylesheet.scss" lang="scss"/>

<script>

import {store} from "../../store/store";
import Vue from "vue";
import axios from "axios";

import {required, minLength, sameAs} from 'vuelidate/src/validators';

export default {
    name: "NavBar",
    data() {
        return {
            searchText: null,
            badges: {
                nShopsToValidate: null
            },

            // For roles: if is null anyone can see, if is 0 only authenticated, -1 only unauthenticated
            // The others based on role
            navItems: [
                { name: 'Categorie disponibili', path: '/', icon: 'home', roles: null },
                { name: 'Aggiungi o modifica il tuo negozio', path: '/login', icon: 'sign-in-alt', roles: [-1] },
                { name: 'Il progetto', path: '/about', icon: 'bullhorn', roles: null },
                { name: 'Il tuo profilo', path: '/dashboard', icon: 'user', roles: [0] },
                { name: 'Negozi da validare', path: '/dashboard/validazione-negozi', icon: 'check', roles: [1,2], badge: 'nShopsToValidate' },
                { name: 'Negozi', path: '/dashboard/lista-negozi', icon: 'store-alt', roles: [1,2] },
                { name: 'Crea negozio', path: '/dashboard/crea-negozio', icon: 'cart-plus', roles: [1,2] },
                { name: 'Accounts', path: '/dashboard/lista-account', icon: 'user-friends', roles: [1] },
                //{ name: 'Categorie', path: '/dashboard/lista-account', icon: '', roles: [1] },

                { name: 'Il tuo negozio', path: '/dashboard/modifica-negozio/' + this.$store.getters.storeId, icon: 'store-alt', roles: [3] },
            ],

            changePasswordObj: {
                oldPassword: null,
                newPassword: null,
                repeatNewPassword: null
            },

            error: null
        }
    },
    validations: {
        changePasswordObj: {
            oldPassword: {
                required
            },
            newPassword: {
                required,
                minLength: minLength(6)
            },
            repeatNewPassword: {
                required,
                sameAs: sameAs('newPassword')
            }
        }
    },
    computed: {
        userState() {
            return this.$store.getters.isAuthenticated;
        }
    },
    mounted() {
        this.getToValidateCount();
    },
    methods: {
        go(where) {
            this.$router.push({path: where}).catch(err => err);
        },
        canViewPage(roles) {
            return roles === null ||
                (this.$store.getters.isAuthenticated ?
                    roles.includes(0) || roles.includes(this.$store.getters.accountTypeId) :
                        roles.includes(-1))
        },
        logout() {
            this.$store.commit("deauthenticateUser");
        },
        search() {
            this.searchText = this.searchText.replace(/[^a-zA-Z0-9 ]/g, "");
            if (this.searchText !== null && this.searchText !== '')
                this.go('/cerca/' + this.searchText + '/' + 10 + '/' + 0);
            this.searchText = '';
        },
        getToValidateCount() {
            if (store.getters.accountTypeId === Vue.Account.ADMIN ||
                store.getters.accountTypeId === Vue.Account.MUNICIPAL) {

                axios({
                    method: "GET",
                    "url": "/store/admin/count",
                    headers: {
                        Authorization: 'Bearer ' + store.getters.token
                    }
                }).then((result) => {
                    this.badges.nShopsToValidate = result.data.value;
                    setTimeout(this.getToValidateCount, 10000);
                }).catch((error) => {
                    this.error = error.data.error;
                    this.$bvModal.show('error-modal');
                    setTimeout(this.getToValidateCount, 10000);
                });
            }
        },
        changePassword() {
            axios({
                method: "PUT",
                "url": "/account/admin/password",
                headers: {
                    Authorization: 'Bearer ' + store.getters.token
                },
                data: this.changePasswordObj
            }).then(() => {
                this.$bvModal.msgBoxOk('La password è stata modificata correttamente.', {
                    title: 'Ottimo!',
                    okVariant: 'success',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                });
                this.resetChangePasswordModal();
            }).catch((error) => {
                this.error = error.response.data.error;
                this.$bvModal.show('error-modal-change-password');
            });
        },
        closeModal() {
            this.$bvModal.hide('edit-password');
            this.resetChangePasswordModal();
        },
        resetChangePasswordModal() {
            this.changePasswordObj = {
                oldPassword: null,
                newPassword: null,
                repeatNewPassword: null
            }
        }
    },
}

</script>
